import { graphql } from 'gatsby';
import React from 'react';
import { SanityImageType } from '../../../graphql-fragments/SanityImage';
import { CommonModuleProps } from '../../ModulesContent';
import Image from '../Image';
import ModuleLayout from '../ModuleLayout';
import * as styles from './TrustStripModule.module.scss';

export const TrustStripModuleFragment = graphql`
  fragment TrustStripModule on SanityTrustStripModule {
    items {
      icon {
        ...SanityImage
      }
      headline {
        ...LocaleStringFragment
      }
      description {
        ...LocaleStringFragment
      }
    }
  }
`;

interface TrustStripItem {
  icon: SanityImageType;
  headline: string;
  description: string;
}

export type TrustStripModuleProps = {
  items: Array<TrustStripItem>;
  className?: string;
};

function renderItem(item: TrustStripItem) {
  return (
    <div className={styles.item}>
      <Image className={styles.icon} image={item.icon} width={48} />
      <div className={styles.textBlock}>
        <p className={styles.headline}>{item.headline}</p>
        <p className={styles.description}>{item.description}</p>
      </div>
    </div>
  );
}

function TrustStripModule(props: TrustStripModuleProps & CommonModuleProps): React.ReactElement {
  const { items, className, moduleId } = props;
  const isWide = items.length >= 4;

  if (isWide) {
    const mid = Math.ceil(items.length / 2);
    const firstHalf = items.slice(0, mid);
    const secondHalf = items.slice(mid);

    return (
      <ModuleLayout
        id={moduleId}
        className={className}
        contentClassName={styles.wideContent}
        currentModuleBgColor={props.theme}
      >
        <div className={`${styles.container} ${styles.wide}`}>
          <div className={styles.pair}>
            {firstHalf.map((item, i) => (
              <React.Fragment key={i}>
                {i > 0 && <div className={styles.divider} />}
                {renderItem(item)}
              </React.Fragment>
            ))}
          </div>
          <div className={styles.pairDivider} />
          <div className={styles.divider + ' ' + styles.hideDividerOnWrap} />
          <div className={styles.pair}>
            {secondHalf.map((item, i) => (
              <React.Fragment key={i}>
                {i > 0 && <div className={styles.divider} />}
                {renderItem(item)}
              </React.Fragment>
            ))}
          </div>
        </div>
      </ModuleLayout>
    );
  }

  return (
    <ModuleLayout id={moduleId} className={className} currentModuleBgColor={props.theme}>
      <div className={`${styles.container} ${items.length >= 3 ? styles.threeItems : ''}`}>
        {items.map((item, i) => (
          <React.Fragment key={i}>
            {i > 0 && <div className={styles.divider} />}
            {renderItem(item)}
          </React.Fragment>
        ))}
      </div>
    </ModuleLayout>
  );
}

export default TrustStripModule;
